import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { useCallback, useState, } from 'react';
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormError from '@enquiryForm/components/FormError';
import FormGroup from '@enquiryForm/components/FormGroup';
import AddressSearch from 'react-loqate';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import DropdownInput from '@widgets/shared/components/form-controls/DropdownInput';
import countries from '@widgets/shared/countries';
import { useEffect, useMemo } from 'preact/compat';
import useKeyedWatch from '@widgets/GenericBookings/hooks/useKeyedWatch';
import { DummyLink } from '@widgets/GenericBookings/components/AttendeesSelector/styles/SelectedAttendees';
function AddressInput(props) {
    const { addressLineOneName, addressLineTwoName, addressTownName, addressPostcodeName, addressCountry, inputAttrs, labelAttrs, forceError, forceOpen, } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control, setValue, getValues } = useFormContext();
    const { field: { value }, fieldState: { invalid, isTouched, error }, } = useController({ name, control });
    const values = useKeyedWatch([
        addressLineOneName,
        addressLineTwoName,
        addressTownName,
        addressPostcodeName,
        addressCountry,
    ]);
    const displayInnerFields = useMemo(() => Object.keys(values).some((key, idx) => values[key] !== ''), [values]);
    const [editing, setEditing] = useState(displayInnerFields);
    const [selectedCountry, setSelectedCountry] = useState(getValues(addressCountry) ?? '');
    useEffect(() => {
        setEditing(displayInnerFields);
    }, [displayInnerFields]);
    const className = clsx('form__control', forwardedInputClasses, { invalid: invalid && isTouched });
    const handleInputChange = useCallback((ev) => {
        setValue(name, ev.currentTarget.value, { shouldTouch: true, shouldValidate: true });
    }, [name, setValue]);
    const onAddressButtonClick = useCallback(() => {
        setEditing(!editing);
    }, [setEditing, editing]);
    // get the api key from an .env file or something..
    return (_jsxs(FormGroup, { className: error ? 'form__group--error address' : 'address', children: [_jsxs("div", { className: "address__form", children: [_jsxs("div", { className: "form__group", children: [_jsx(FormLabel, { ...labelAttrs }), _jsx(AddressSearch, { ...inputAttrs, locale: "en-GB", apiKey: "YP87-XX68-WD83-DP99", className: className, onSelect: (address) => {
                                    setValue(addressTownName, address.City, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
                                    setValue(addressLineOneName, address.Line1, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
                                    setValue(addressLineTwoName, address.Line2, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
                                    setValue(addressPostcodeName, address.PostalCode, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
                                    setValue(addressCountry, address.CountryName, { shouldDirty: true, shouldTouch: true, shouldValidate: true });
                                    setSelectedCountry(address.CountryName ?? '');
                                } }), !(editing || forceOpen) && (_jsx(DummyLink, { onClick: () => setEditing(true), children: "Can't find your address?" }))] }), (editing || forceOpen) && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form__address", children: [_jsx("span", { className: "form__label", children: "Address" }), _jsx(TextInput, { inputAttrs: {
                                            id: 'address-1',
                                            name: addressLineOneName,
                                            type: 'string',
                                        }, labelAttrs: {
                                            htmlFor: 'address-1',
                                            text: 'Address Line 1',
                                            isFieldRequired: true,
                                            hidden: true,
                                        }, forceError: forceError }), _jsx(TextInput, { inputAttrs: {
                                            id: 'address-2',
                                            name: addressLineTwoName,
                                            type: 'string',
                                        }, labelAttrs: {
                                            htmlFor: 'address-2',
                                            text: 'Address Line 2',
                                            isFieldRequired: false,
                                            hidden: true,
                                        }, forceError: forceError })] }), _jsx(TextInput, { inputAttrs: {
                                    id: 'address-town',
                                    name: addressTownName,
                                    type: 'string',
                                }, labelAttrs: {
                                    htmlFor: 'address-town',
                                    text: 'Town/City',
                                    isFieldRequired: true,
                                }, forceError: forceError }), _jsx(TextInput, { inputAttrs: {
                                    id: 'address-postcode',
                                    name: addressPostcodeName,
                                    type: 'string',
                                }, labelAttrs: {
                                    htmlFor: 'address-postcode',
                                    text: 'Postcode',
                                    isFieldRequired: true,
                                }, forceError: forceError }), _jsx(DropdownInput, { inputAttrs: {
                                    name: addressCountry,
                                    // id: 'country',
                                    options: countries.map((country) => ({
                                        value: country,
                                        label: country,
                                    })),
                                    value: selectedCountry,
                                }, labelAttrs: {
                                    htmlFor: 'country',
                                    text: 'Country',
                                    isFieldRequired: true,
                                }, forceError: true })] }))] }), (error && (isTouched || forceError)) && (_jsx(FormError, { children: error?.message }))] }));
}
AddressInput.defaultProps = {
    forceOpen: false,
    forceError: false,
};
export default AddressInput;
